import * as React from 'react'
import MenuItem from '@mui/material/MenuItem'
import { Field } from 'formik'

import type { LocationDTO } from '@sales-center/common'
import { BaseTextField } from '@user/components/Formik'

import { useLocationSelect } from './useLocationSelect'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'

export type LocationSelectProps = {
  serviceLocations: LocationDTO[]
}

export function LocationSelect(props: LocationSelectProps) {
  const { locationOptions, onChange } = useLocationSelect(props)
  const tidalThemeActive = useTidalThemeActive()

  return (
    <Field
      select
      size={tidalThemeActive ? 'medium' : 'small'}
      label="Service Location"
      onChange={onChange}
      name="serviceLocationId"
      component={BaseTextField}
      inputProps={{
        'data-test-id': `locAndSvcs-locSelect`,
      }}
    >
      <MenuItem value="" disabled>
        Select Location
      </MenuItem>
      {locationOptions.map(({ id, label }) => (
        <MenuItem key={id} value={id} data-test-id={`locAndSvcs-locOpt-${id}`}>
          {label}
        </MenuItem>
      ))}
    </Field>
  )
}
